<p-button
  [styleClass]="'w-auto' + (styleClass ? ' ' + styleClass : '')"
  [rounded]="true"
  severity="secondary"
  [text]="true"
  [label]="'abbrechen'"
  (click)="cancel()"
  [icon]="'fas fa-circle-xmark'"></p-button>
